import Vue from "vue";
import App from "./App";
import router from "./router";
import "./assets/css/reset.css";
import "./assets/css/common.css";
import "./assets/css/root.css";
import "./assets/css/iconfont/iconfont.css";
import axios from "axios";
import store from "./store";
import qs from "qs"; //json字符串转为表单格式插件
import md5 from "blueimp-md5"; //md5加密插件
import EventBus from "./utils/eventBus";
import ryan from "./ryan";
import { Icon } from "element-ui";
import "element-ui/lib/theme-chalk/base.css";

import Skeleton from "./components/skeleton.vue";
import i18n from "./i18n";
import { isTimeoutError, notifyNetworkError } from "./utils/networkError";
// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    //在拦截器里统一处理将json参数格式改成表达格式
    let param = config.data,
      params = config.params;
    if (param && typeof param === "object" && !param.append) {
      config.data = qs.stringify(param);
    }
    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    if (response.data.data) {
      let code = response.data.data.code;
      if (code === 700) {
        // 登录失效后，清除登录信息，并跳转至首页 显示登录框
        localStorage.removeItem("uid");
        localStorage.removeItem("token");
        store.commit("getUserInfo", {});
        EventBus.$emit("loginOut");
        EventBus.$emit("loginShow");
        router.push("/");
      }
    }
    return response;
  },
  function (error) {
    let config = error.config;
    if (!config || !config.retry || !isTimeoutError(error)) {
      notifyNetworkError();
      return Promise.reject(error);
    }
    config.__retryCount = config.__retryCount || 0;
    if (config.__retryCount >= config.retry) {
      notifyNetworkError();
      return Promise.reject(error);
    }
    config.__retryCount += 1;
    let backoff = new Promise((resolve) => {
      setTimeout(() => resolve(), config.retryDelay || 1);
    });
    return backoff.then(function () {
      return axios(config);
    });
  }
);

//事件总线
Vue.prototype.$EventBus = EventBus;

Vue.prototype.$ryan = ryan;
Vue.prototype.md5 = md5;
Vue.prototype.$axios = axios;
// window.newlive 关键代码(旧) 测试api地址：http://liveapi.zbitcloud.com 正式api地址：http://eliveapi.ttmna.com
axios.defaults.baseURL =
  process.env.NODE_ENV === "production" ? "/h5/api" : "/obapi";
axios.defaults.timeout = 10000;
axios.defaults.retry = 1;
axios.defaults.retryDelay = 1000;

Vue.config.productionTip = false;

import VueLazyload from "vue-lazyload"; //图片懒加载

Vue.use(VueLazyload, {
  loading: require("./assets/img/loading.png"), //加载中图片，一定要有，不然会一直重复加载占位图
  error: require("./assets/img/error.png"), //加载失败图片
  attempt: 3, //尝试加载次数
});

// Some on-demand Element components render ElIcon internally.
Vue.component(Icon.name, Icon);
Vue.component("Skeleton", Skeleton);
const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
});

// Keep the static startup skeleton visible until the first async route is ready.
router.onReady(
  () => app.$mount("#app"),
  () => app.$mount("#app")
);



// WEBPACK FOOTER //
// ./src/main.js